import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { checkInvAccess } from 'src/app/constants';

@Component({
	selector: 'app-breaks',
	templateUrl: './breaks-detailview.component.html',
	styleUrls: [],})
export class BreaksDetailviewComponent implements ICellRendererAngularComp {
  params;
  label: string;
  isDisable: boolean;
  showbutton: boolean = false;
  access
  addEditShifts

  agInit(params): void {
    this.params = params;
    this.access = checkInvAccess();
    this.addEditShifts = this.access?.functionalityAccess?.addEditShifts || false;
  }

  refresh(params?: any): boolean {
    return true;
  }

  onClick() {
    if (this.params.onClick instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        rowData: this.params.node.data,
        // ...something
      };
      this.params.onClick();
    }
  }
  showbreak() {
    this.params.context.componentParent.showbreak(
      this.params.data
    );

  }
}
